import * as React from "react";
import { Button, DatePicker, Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import { onError } from "src/common/onError";
import { ZUid } from "src/types/zUid";
import { EntityAuditStore } from "./EntityAuditStore";
import { EntityAuditList } from "./EntityAuditList";
import styles from "./EntityAudit.module.less";
import { AuditFilterUI } from "./ZEntityAudit";

interface PropsEntityAudit {
  entityId: ZUid;
  store: EntityAuditStore;
}

export const EntityAudit: React.FC<PropsEntityAudit> = observer((props) => {
  const { store, entityId } = props;
  const [form] = Form.useForm<AuditFilterUI>();
  React.useEffect(() => {
    store.init(entityId).catch(onError);
  }, []);
  React.useEffect(() => {
    form.setFieldsValue(store.filter);
  }, [store.filter]);
  const needMore: boolean = !!store.nextPageToken;
  return (
    <div className={styles.auditFrame}>
      <div className={styles.title}>Изменение версии экземпляра</div>

      <Form<AuditFilterUI>
        form={form}
        className={styles.filterBox}
        layout="vertical"
        onValuesChange={(_, values) => {
          store.onFilterChange(values).catch(onError);
        }}
      >
        <Form.Item label="Период" name="range">
          <DatePicker.RangePicker />
        </Form.Item>
        <Form.Item label="Пользователь" name="userId">
          <Select
            loading={store.usersListLoading}
            options={store.usersList ?? []}
            allowClear
          />
        </Form.Item>
      </Form>

      <EntityAuditList
        loading={store.loading}
        list={store.list}
        onAuditEvent={(e) => store.onAuditEvent(e)}
      />

      {needMore && (
        <div className={styles.moreBox}>
          <Button
            disabled={store.loading}
            size="small"
            loading={store.loading}
            onClick={() => {
              store.loadNextPage().catch(onError);
            }}
          >
            Показать больше
          </Button>
        </div>
      )}
    </div>
  );
});
